import { fg } from '@confluence/feature-gating';

/**
 * Returns whether the current tenant has opted out of Remix. The
 * `cc-maui-opted-out` gate is enabled for opted-out tenants only.
 *
 * Opting out hides every entrypoint for generating or editing a Remix. It does
 * NOT stop an existing Remix from being viewed — rendering, resizing and
 * loading of already-generated content must keep working.
 *
 * Checked before any `cc-maui-experiment` evaluation so opted-out users never
 * fire a `cc-maui-experiment` exposure.
 */
// eslint-disable-next-line confluence-feature-gating/inline-usage, confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
export const isRemixOptedOut = (): boolean => fg('cc-maui-opted-out');
